const STORAGE_KEY = 'fortio_transport_queue_read';

function getReadSet() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function persistReadSet(set) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
}

export function transportQueueNotificationKey(freightId, idTransport) {
  return `${freightId}:${idTransport}`;
}

export function isTransportQueueNotificationRead(freightId, idTransport) {
  if (!freightId || !idTransport) return false;
  return getReadSet().has(transportQueueNotificationKey(freightId, idTransport));
}

export function markTransportQueueNotificationRead(freightId, idTransport) {
  if (!freightId || !idTransport) return;
  const set = getReadSet();
  set.add(transportQueueNotificationKey(freightId, idTransport));
  persistReadSet(set);
}

export const TRANSPORT_QUEUE_FREIGHT_STATUSES = [
  'Pendente de validação',
  'P. Validação',
  'Pendente de contratação',
  'P.Contratação',
];

export function isFreightPendingContract(freightData) {
  const describe = String(freightData?.status?.describe ?? '').trim();
  const code = String(freightData?.status?.code ?? '').trim();
  const isPendingValidation =
    describe === 'P. Validação' ||
    describe === 'Pendente de validação' ||
    code === '00';

  return (
    isPendingValidation ||
    describe === 'P.Contratação' ||
    describe === 'Pendente de contratação' ||
    code === '01'
  );
}

export function resolveShipperUidFromFreight(freightData) {
  return String(
    freightData?.clientPayment?.uid ||
      freightData?.client?.uid ||
      freightData?.pagador ||
      freightData?.freight?.pagador ||
      '',
  ).trim();
}

export function parseFreightsV2Items(response) {
  const root = response?.data ?? {};
  if (Array.isArray(root.data)) return root.data;
  if (Array.isArray(root.items)) return root.items;
  if (Array.isArray(root)) return root;
  return [];
}

export function mapApiFreightForNotification(item) {
  if (!item || typeof item !== 'object') return {};

  const status = item.status || {
    describe: item.statusDescribe ?? item.status_text ?? '',
    code: item.statusCode ?? item.status_code ?? '',
  };

  return {
    numberSerial: item.numberSerial ?? item.code ?? item.serial,
    firstDelivery: item.firstDelivery || {
      city: item.origin?.city,
    },
    lastDelivery: item.lastDelivery || {
      city: item.destination?.city,
    },
    status,
    clientPayment: item.clientPayment || {
      uid: item.client?.uid,
      name: item.client?.name,
    },
    pagador: item.pagador,
    freight: item.freight,
  };
}

export function chunkArray(items, size) {
  if (!Array.isArray(items) || !items.length) return [];
  const chunks = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}

export function buildTransportQueueNotification({
  freightId,
  freightData,
  transportItem,
  shipperUid,
}) {
  const origin =
    freightData?.firstDelivery?.city || 'Origem não informada';
  const destination =
    freightData?.lastDelivery?.city || 'Destino não informado';
  const freightNumber = freightData?.numberSerial || freightId;
  const transportName = transportItem?.name || 'Transportadora';
  const idTransport = transportItem?.idTransport || '';

  return {
    id: `transport_${freightId}_${idTransport}`,
    type: 'transportQueue',
    freightId,
    freightNumber,
    shipperUid,
    idTransport,
    transportName,
    origin,
    destination,
    title: `${transportName} entrou na fila do frete!`,
    description: `${origin} → ${destination} · #${freightNumber}`,
    date: transportItem?.registeredAt || new Date(),
    read: false,
  };
}
